import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Units } from 'Css';

export const colors = {
  creen: { r: 26, g: 188, b: 156 },
  green: { r: 39, g: 174, b: 96 },
  blue: { r: 52, g: 152, b: 219 },
  blue2: { r: 41, g: 128, b: 185 },
  purple: { r: 155, g: 89, b: 182 },
  navyblue: { r: 52, g: 73, b: 94 },
  gray: { r: 127, g: 140, b: 141 },
  red: { r: 192, g: 57, b: 43 },
  lightgreen: { r: 102, g: 215, b: 119 },
  teal: { r: 1, g: 150, b: 149 },
  mustard: { r: 146, g: 144, b: 25 },
  darkblue: { r: 16, g: 84, b: 147 },
  golden: { r: 209, g: 206, b: 98 },
  mango: { r: 249, g: 195, b: 50 },
  pinktaco: { r: 238, g: 124, b: 182 },
  pinkster: { r: 241, g: 141, b: 139 },
  orange: { r: 243, g: 147, b: 49 },
  love: { r: 168, g: 51, b: 81 },
  purplehaze: { r: 128, g: 44, b: 106 },
  raspberry: { r: 237, g: 76, b: 124 },
  white: { r: 255, g: 255, b: 255 },
  black: { r: 0, g: 0, b: 0 }
};

const css = oxygenCss({
  root: {
    position: 'relative',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    '@mobile': {
      flexDirection: 'column'
    },
    '&size1': {
      height: Units.keyline * 3,
      '@phone': {
        height: Units.keyline * 1.5
      }
    },
    '&size2': {
      height: Units.keyline * 6,
      '@phone': {
        height: Units.keyline * 3
      }
    },
    '&size3': {
      height: Units.keyline * 9,
      '@phone': {
        height: Units.keyline * 4.5
      }
    },
    ' H1': {
      ':only-child': {
        margin: 0
      }
    },
    ' H2': {
      ':only-child': {
        margin: 0
      }
    },
    ' H3': {
      ':only-child': {
        margin: 0
      }
    },
    ' H4': {
      ':only-child': {
        margin: 0
      }
    },
    ' H5': {
      ':only-child': {
        margin: 0
      }
    },
    ' H6': {
      ':only-child': {
        margin: 0
      }
    },
    ' P': {
      ':only-child': {
        margin: 0
      }
    }
  },
  overlay: {
    transition: 'opacity 0.25s all',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 1
  },
  headerWrapper: {
    position: 'relative',
    zIndex: 2,
    padding: Units.base * 3,
    transition: 'all 0.25s ease'
  },
  header: {
    '>DIV': {
      whiteSpace: 'pre-line'
    },
    '>P': {
      whiteSpace: 'pre-line'
    },
    ' H1': {
      '@phone': {
        fontSize: 20,
        lineHeight: '28px'
      }
    }
  },
  centerCenter: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  leftCenter: {
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  rightCenter: {
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  topLeft: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  topCenter: {
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  topRight: {
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
  },
  bottomLeft: {
    alignItems: 'flex-end',
    justifyContent: 'flex-start'
  },
  bottomCenter: {
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  bottomRight: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  }
});

class StoreBannerModule extends Component {
  static propTypes = {
    src: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
    opacity: PropTypes.number,
    backgroundColor: PropTypes.string,
    header: PropTypes.string,
    headerPosition: PropTypes.string
  };

  static defaultProps = {
    size: 1,
    opacity: 0.25,
    color: '#FFFFFF',
    backgroundColor: '#000000',
    headerPosition: 'centerCenter'
  };

  render() {
    const {
      src,
      size,
      opacity,
      header,
      color,
      backgroundColor,
      headerPosition
    } = this.props;
    return (
      <div
        className={classNames(
          css.root,
          css[`size${size}`],
          css[headerPosition]
        )}
        style={{ color, backgroundImage: `url(${src})` }}
      >
        <div className={css.overlay} style={{ backgroundColor, opacity }} />
        <div className={css.headerWrapper}>
          {!header.includes('<h1>null</h1>') && <div
            className={css.header}
            dangerouslySetInnerHTML={{ __html: header }}
          />}
        </div>
      </div>
    );
  }
}

export default StoreBannerModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreBannerModule.js